import kamala from '../../kamala'
import Empty from './Empty'

Empty.install = function (Vue) {
  kamala(Vue)
  Vue.component(Empty.name, Empty)
}

export default Empty
